const initSelect = (originalSelect) => {
    let originalOptions = originalSelect.querySelectorAll('option');
    if (originalSelect.required && originalSelect.querySelector('option:checked')) {
        originalOptions = Array.from(originalOptions).filter((option) => option.value);
    }
    const selectContainer = document.createElement('div');
    selectContainer.classList.add(...originalSelect.classList.values());
    selectContainer.classList.add('advanced-select-container');
    const selectInput = document.createElement('input');
    selectInput.type = 'text';
    selectInput.name = originalSelect.name;
    selectInput.style.setProperty('position', 'absolute');
    selectInput.style.setProperty('width', '0');
    selectInput.style.setProperty('height', '0');
    selectInput.style.setProperty('visibility', 'hidden');
    if (originalSelect.id) {
        selectInput.id = originalSelect.id;
    }
    const selectDisplayValue = document.createElement('div');
    selectDisplayValue.classList.add('display-option');
    const selectOptions = document.createElement('ul');
    selectOptions.classList.add('select-options');
    selectContainer.appendChild(selectInput);
    selectContainer.appendChild(selectDisplayValue);
    selectContainer.appendChild(selectOptions);
    const selectOption = (option) => {
        selectInput.value = option.dataset.value || '';
        selectDisplayValue.innerHTML = option.innerHTML;
        selectOptions.querySelectorAll('li').forEach((li) => li.classList.toggle('active', option === li));
        selectOptions.classList.remove('active');
    };
    originalOptions.forEach((originalOption, index) => {
        const newOption = document.createElement('li');
        newOption.innerText = originalOption.innerText;
        newOption.dataset.value = originalOption.value;
        selectOptions.appendChild(newOption);
        if (originalOption.selected) {
            selectOption(newOption);
        }
        newOption.addEventListener('click', (event) => {
            if (selectOptions.classList.contains('active')) {
                selectOption(newOption);
            }
        });
    });
    selectDisplayValue.addEventListener('click', () => {
        selectOptions.classList.toggle('active');
    });
    originalSelect.replaceWith(selectContainer);
    document.addEventListener('click', (event) => {
        if (event.target === selectDisplayValue ||
            (event.target instanceof HTMLElement && event.target.parentElement === selectDisplayValue)) {
            return;
        }
        if (selectOptions.classList.contains('active')) {
            selectOptions.classList.toggle('active', false);
        }
    });
};
export const initAdvancedSelects = () => {
    const init = () => {
        const selects = document.querySelectorAll('.advanced-select-form select');
        selects.forEach((select) => initSelect(select));
    };
    document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
};
